import { render, staticRenderFns } from "./PodcastContent.vue?vue&type=template&id=476c97c2&"
import script from "./PodcastContent.vue?vue&type=script&lang=js&"
export * from "./PodcastContent.vue?vue&type=script&lang=js&"
import style0 from "./PodcastContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports